import {ClientSummary, Contact, Event, EventAlertState, EventType, Site} from "../api/dtos/dtos";
import * as moment from "moment";
import {MOMENT_DATE_FORMAT, MOMENT_TIME_FORMAT, toApiDateFormat} from "../utils/date-utils";

export const createEventDto = (e: Event): EventDto => {
  return new EventDto(
    e.id, e.userName,
    e.client ?? undefined,
    e.contact ?? undefined,
    e.site ?? undefined,
    e.subject,
    e.comment,
    moment(e.start),
    moment(e.end),
    e.alertDate ? moment(e.alertDate) : undefined,
    e.alertHandled ?? undefined,
    e.type,
    e.alertState,
    e.completed,
    e.hasAttachments,
  );
}

export class EventDto {
  public readonly id: number | null;
  public readonly userName: string;
  public readonly client: ClientSummary | undefined;
  public readonly contact: Contact | undefined;
  public readonly type: EventType;
  public readonly site: Site | undefined;
  public readonly subject: string;
  public readonly comment: string | null;
  public readonly start: moment.Moment;
  public readonly end: moment.Moment;
  public alertDate: moment.Moment | undefined;
  public alertHandled: boolean | undefined;
  public alertState: EventAlertState | undefined;
  public completed: boolean | undefined;
  public hasAttachments: boolean | undefined;


  constructor(
    id: number | null,
    userName: string,
    client: ClientSummary | undefined,
    contact: Contact | undefined,
    site: Site | undefined,
    subject: string,
    comment: string | null,
    start: moment.Moment,
    end: moment.Moment,
    alertDate: moment.Moment | undefined,
    alertHandled: boolean | undefined,
    type: EventType,
    alertState: EventAlertState | undefined,
    completed: boolean | undefined,
    hasAttachments: boolean | undefined,
  ) {
    this.id = id;
    this.userName = userName;
    this.client = client;
    this.contact = contact;
    this.site = site;
    this.subject = subject;
    this.start = start;
    this.end = end;
    this.comment = comment;
    this.alertDate = alertDate;
    this.alertHandled = alertHandled;
    this.type = type;
    this.alertState = alertState;
    this.completed = completed;
    this.hasAttachments = hasAttachments;
  }

  public getTitle(): string {
    return `${this.subject} - ${this.start.format(MOMENT_DATE_FORMAT)} ${this.start.format(MOMENT_TIME_FORMAT)} - ${this.end.format(MOMENT_TIME_FORMAT)}`;
  }

  public toEvent(): Event {
    return {
      id: this.id,
      userName: this.userName,
      client: this.client,
      contact: this.contact,
      site: this.site,
      type: this.type,
      subject: this.subject,
      start: toApiDateFormat(this.start),
      end: toApiDateFormat(this.end),
      comment: this.comment,
      alertDate: this.alertDate ? toApiDateFormat(this.alertDate) : null,
      alertHandled: this.alertHandled,
      alertState: this.alertState,
      completed: this.completed,
      hasAttachments: this.hasAttachments,
    };
  }
}


// WEBPACK FOOTER //
// ./src/event-details/dtos.ts